import { Locale } from "@redotech/crdb-enums/common/locale";
import * as z from "zod";

/** Saves the signed-in user's dashboard language (`user.preferredLocale`). */
export const updatePreferredLocale = {
  name: "updatePreferredLocale" as const,
  input: z.object({ locale: z.enum(Locale) }),
  output: z.object({}),
};

export function toPreferredLocale(locale: string): Locale | undefined {
  return Object.values(Locale).find((value) => value === locale);
}
